<template>
  <router-view />
</template>

<script>
export default {
  name: 'Department'
}
</script>

<style>

</style>
